<div class="card p-0 shadow-2 border-round-xl overflow-hidden">
  <p-toast />

  <p-fileUpload
    name="myfile[]"
    url="https://www.primefaces.org/cdn/api/upload.php"
    [multiple]="true"
    accept="image/*"
    (onUpload)="onTemplatedUpload($event)"
    (onSelect)="onSelectedFiles($event)">
    <ng-template
      #header
      let-files
      let-chooseCallback="chooseCallback"
      let-clearCallback="clearCallback"
      let-uploadCallback="uploadCallback">
      <div
        class="flex flex-wrap align-items-center justify-content-between gap-3 w-full p-2">
        <div class="flex gap-2">
          <p-button
            (onClick)="choose($event, chooseCallback)"
            icon="pi pi-plus"
            label="Añadir"
            [rounded]="true"
            [disabled]="totalCount() >= maxFiles()" />

          @if(uploadButtonEnabled()){
          <p-button
            (onClick)="uploadEvent(uploadCallback)"
            icon="pi pi-upload"
            label="Subir"
            [rounded]="true"
            severity="success"
            [disabled]="
              !files || files.length === 0 || totalCount() > maxFiles()
            " />
          }
          <p-button
            (onClick)="removeAllImages(); clearCallback($event)"
            icon="pi pi-trash"
            [rounded]="true"
            severity="danger"
            [outlined]="true"
            [disabled]="!files || files.length === 0" />
        </div>

        <div class="font-bold flex align-items-center gap-2">
          @if(totalCount() > maxFiles()){
          <i class="pi pi-exclamation-triangle color-error"></i>
          }
          <span [class.color-error]="totalCount() > maxFiles()" class="text-sm">
            {{ totalCount() }} / {{ maxFiles() }}
          </span>
        </div>
      </div>
    </ng-template>

    <ng-template #content let-files let-removeFileCallback="removeFileCallback">
      @if (totalCount() > 0) {
      <div class="grid mt-2">
        <div
          *ngFor="let url of initialImages(); let i = index"
          class="col-12 sm:col-6 md:col-4 lg:col-3">
          <div
            class="file-card p-3 border-round-lg border-1 surface-100 border-300 shadow-1">
            <div class="image-container mb-2 bg-white">
              <img [src]="url" class="preview-img" />
            </div>
            <p-button
              icon="pi pi-trash"
              (onClick)="removeInitialImage(i)"
              label="Borrar"
              severity="danger"
              [text]="true"
              size="small"
              class="w-full" />
          </div>
        </div>

        @for (file of uploadedPersistedImages(); track $index) {
        <div class="col-12 sm:col-6 md:col-4 lg:col-3">
          <div
            class="file-card p-3 border-round-lg border-1 border-green-200 bg-green-50 shadow-1">
            <div class="image-container mb-2 bg-white">
              <img [src]="file.objectURL" class="preview-img" />
            </div>
            <span class="text-xs truncate font-bold text-900 block mb-2">{{
              file.name
            }}</span>
            <div class="flex align-items-center justify-content-between">
              @if(uploadButtonEnabled()){
              <p-badge value="Subido" severity="success" />}
              <p-button
                icon="pi pi-trash"
                (onClick)="removePersistedImage($index)"
                severity="danger"
                [text]="true" />
            </div>
          </div>
        </div>
        } @if(uploadButtonEnabled()){ @for (file of files; track $index) {
        <div class="col-12 sm:col-6 md:col-4 lg:col-3">
          <div
            class="file-card p-3 border-round-lg border-1 border-200 surface-card shadow-1">
            <div class="image-container mb-2">
              <img [src]="file.objectURL" class="preview-img" />
            </div>
            <span class="text-xs truncate font-bold text-900 block mb-2">{{
              file.name
            }}</span>
            <div class="flex align-items-center justify-content-between">
              <p-badge value="Pendiente" severity="warn" />
              <p-button
                icon="pi pi-trash"
                (onClick)="removeFileCallback($event, $index)"
                severity="danger"
                [text]="true" />
            </div>
          </div>
        </div>
        } }
      </div>
      } @else {
      <div
        class="flex flex-column align-items-center justify-content-center py-8 w-full border-2 border-dashed border-300 border-round-xl surface-ground mt-4">
        <i class="pi pi-cloud-upload text-4xl text-400 mb-3"></i>
        <span class="text-600 font-medium">{{ placeholderContent() }}</span>
      </div>
      }
    </ng-template>
  </p-fileUpload>
</div>
